'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled"];
import { useContext } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { DisabledContext } from '../toolbar/Disableable';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withDisabledContext(WrappedComponent) {
  function WithDisabled(props) {
    const {
        disabled
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const disabledContext = useContext(DisabledContext);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      disabled: disabled || disabledContext || false
    }, rest));
  }
  WithDisabled.displayName = `WithDisabled(${getComponentName(WrappedComponent)})`;
  return WithDisabled;
}